import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  Carriers,
  TRANSPORT_METHOD_TYPE,
} from '@savgroup-front-common/core/api/Claim/getClaimGroupTransportPlanQuery';

import { PickupPointOption } from '../../../../../../../IrshPages.types';

import { ICON_TYPE } from './MapWithControlledZoom.constants';

export const getDefaultIconUrl = ({
  type,
  carrierBrand,
  chain,
}: {
  type: string;
  carrierBrand: string;
  chain: string;
}) => {
  const iconsPath = {
    [ICON_TYPE.POINT]: `${APIConfiguration.catalogCDN}carriers/marker_${(
      chain ||
      carrierBrand ||
      'external'
    ).toLowerCase()}.svg`,
    [ICON_TYPE.SELECTED_POINT]: `${
      APIConfiguration.catalogCDN
    }carriers/marker_${(
      chain ||
      carrierBrand ||
      'external'
    ).toLowerCase()}_selected.svg`,
  };

  return iconsPath[type];
};

export const getDefaultSellerUIconUrl = ({
  sellerId,
  type,
}: {
  sellerId: string;
  type: string;
}) => {
  const iconsPath = {
    [ICON_TYPE.POINT]: `${APIConfiguration.imageCDN}sellers/${sellerId}.png`,
    [ICON_TYPE.SELECTED_POINT]: `${APIConfiguration.imageCDN}sellers/${sellerId}.png`,
  };

  return iconsPath[type];
};

export const getIconFromPublicDocumentsPath = ({
  type,
  carrierBrand,
  chain,
  sellerId,
}: {
  type: string;
  carrierBrand: string;
  chain: string;
  sellerId: string;
}) => {
  const iconsPath = {
    [ICON_TYPE.POINT]: `${
      APIConfiguration.imageCDN
    }sellers/${sellerId}/marker_${(
      chain ||
      carrierBrand ||
      'external'
    ).toLowerCase()}.svg`,
    [ICON_TYPE.SELECTED_POINT]: `${
      APIConfiguration.imageCDN
    }sellers/${sellerId}/marker_${(
      chain ||
      carrierBrand ||
      'external'
    ).toLowerCase()}_selected.svg`,
  };

  return iconsPath[type];
};

export const getUrlsForPickupPoint = ({
  pickupPointOption,
  sellerId,
  marketPlaceName,
}: {
  pickupPointOption: PickupPointOption;
  sellerId: string;
  marketPlaceName?: string;
}) => {
  const transportPlan = pickupPointOption.data.transportPlan;

  const marketPlaceNameLowercase = marketPlaceName?.toLowerCase() || '';
  const isImmediateDepositAtStoreExternalCarrier =
    (marketPlaceName &&
      transportPlan.carrier === Carriers.External &&
      transportPlan.transportMethod ===
        TRANSPORT_METHOD_TYPE.ImmediateDropAtStoreDeposit) ||
    transportPlan.transportMethod === TRANSPORT_METHOD_TYPE.DropAtStoreDeposit;

  const isImmediateDeliveryAtStoreExternalCarrier =
    marketPlaceName &&
    transportPlan.carrier === Carriers.External &&
    transportPlan.transportMethod === TRANSPORT_METHOD_TYPE.PickUpStoreDelivery;

  const isImmediateDropAndPickUpProduct =
    isImmediateDepositAtStoreExternalCarrier ||
    isImmediateDeliveryAtStoreExternalCarrier;

  return {
    markerUrlFromPublicDocument: getIconFromPublicDocumentsPath({
      type: ICON_TYPE.POINT,
      carrierBrand: isImmediateDropAndPickUpProduct
        ? marketPlaceNameLowercase
        : transportPlan.carrier,
      chain: '',
      sellerId,
    }),
    selectedMarkerUrlFromPublicDocument: getIconFromPublicDocumentsPath({
      type: ICON_TYPE.SELECTED_POINT,
      carrierBrand: isImmediateDropAndPickUpProduct
        ? marketPlaceNameLowercase
        : transportPlan.carrier,
      chain: '',
      sellerId,
    }),
    defaultMarkerUrl: getDefaultIconUrl({
      type: ICON_TYPE.POINT,
      carrierBrand: isImmediateDropAndPickUpProduct
        ? marketPlaceNameLowercase
        : transportPlan.carrier,
      chain: '',
    }),
    defaultSelectedMarkerUrl: getDefaultIconUrl({
      type: ICON_TYPE.SELECTED_POINT,
      carrierBrand: isImmediateDropAndPickUpProduct
        ? marketPlaceNameLowercase
        : transportPlan.carrier,
      chain: '',
    }),
  };
};
